<template>

    <div v-if="!html && loading" class="builder loading">
        <div class="builder-content">
            <v-loader size="lg" />
        </div>
    </div>

    <div v-else-if="html" class="builder">
        <v-builder-modals />
        <div class="builder-content">
            <v-builder-header v-if="mode !== 'template'" />
            <div class="builder-body">
                <div class="builder-primary">
                    <v-builder-canvas />
                </div>
                <div class="builder-sidebar">
                    <v-panel-badge v-if="panel === 'badge'" />
                    <v-panel-button v-else-if="panel === 'button'" />
                    <v-panel-code v-else-if="panel === 'code'" />
                    <v-panel-divider v-else-if="panel === 'divider'" />
                    <v-panel-headline v-else-if="panel === 'headline'" />
                    <v-panel-image v-else-if="panel === 'image'" />
                    <v-panel-logo v-else-if="panel === 'logo'" />
                    <v-panel-paragraph v-else-if="panel === 'paragraph'" />
                    <v-panel-social v-else-if="panel === 'social'" />
                    <v-panel-spacer v-else-if="panel === 'spacer'" />
                    <v-panel-unsub v-else-if="panel === 'unsub'" />
                    <v-panel-template v-else />
                </div>
            </div>
        </div>
    </div>

</template>

<style scoped lang="scss">

    .builder {
        height: 100%;
        left: 0;
        min-width: $screen-md-min;
        position: absolute;
        top: 0;
        width: 100%;
        &.loading .builder-content {
            align-items: center;
            justify-content: center;
        }
        .builder-content {
            background: #fff;
            box-sizing: border-box;
            display: flex;
            flex-direction: column;
            flex-grow: 1;
            height: 100%;
            overflow: hidden;
        }
        .builder-body {
            background: #fff;
            display: flex;
            flex-grow: 1;
            overflow: auto;
            .builder-sidebar {
                flex-shrink: 0;
                position: relative;
                overflow: hidden;
                width: 350px;
            }
            .builder-primary {
                display: flex;
                flex-direction: column;
                flex-grow: 1;
            }
        }
    }

</style>

<script>

import BuilderCanvas from './BuilderCanvas';
import BuilderHeader from '@builder/BuilderHeader';
import BuilderModals from '@builder/BuilderModals';
import BuilderUtil from './utils/BuilderUtil';
import ActionApi from '@api/ActionApi';
import PanelBadge from './panels/PanelBadge';
import PanelButton from './panels/PanelButton';
import PanelCode from './panels/PanelCode';
import PanelDivider from './panels/PanelDivider';
import PanelHeadline from './panels/PanelHeadline';
import PanelImage from './panels/PanelImage';
import PanelLogo from './panels/PanelLogo';
import PanelParagraph from './panels/PanelParagraph';
import PanelSocial from './panels/PanelSocial';
import PanelSpacer from './panels/PanelSpacer';
import PanelTemplate from './panels/PanelTemplate';
import PanelUnsub from './panels/PanelUnsub';
import TemplateApi from '@api/TemplateApi';

export default {

    components: {
        'v-panel-badge': PanelBadge,
        'v-panel-button': PanelButton,
        'v-panel-code': PanelCode,
        'v-panel-divider': PanelDivider,
        'v-panel-headline': PanelHeadline,
        'v-panel-image': PanelImage,
        'v-panel-logo': PanelLogo,
        'v-panel-paragraph': PanelParagraph,
        'v-panel-social': PanelSocial,
        'v-panel-spacer': PanelSpacer,
        'v-panel-template': PanelTemplate,
        'v-panel-unsub': PanelUnsub,
        'v-builder-canvas': BuilderCanvas,
        'v-builder-header': BuilderHeader,
        'v-builder-modals': BuilderModals,
    },

    props: {
        mode: {
            type: String,
            default: 'automatic',
        },
        action: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            loading: true,
        }
    },

    mounted() {
        this.getBuilder();
    },

    updated() {
        BuilderUtil.saveBlocks();
    },

    beforeDestroy() {
        this.$store.commit('builder/reset');
    },

    computed: {

        html() {
            return this.$store.getters['builder/html'];
        },

        panel() {
            return this.$store.getters['builder/selectedPanel'];
        },

    },

    methods: {

        getBuilder() {
            this.loading = true;
            (this.mode !== 'template' ? ActionApi : TemplateApi).getBuilder(this.action.id)
                .then((response) => {
                    this.loading = false;
                    this.setCss(response.data.data.css);
                    this.$store.commit('builder/setMode', this.mode);
                    this.$store.commit('builder/setHtml', response.data.data.html);
                    this.$store.commit('builder/setLibrary', response.data.data.library);
                    this.$store.commit('builder/setLibraryCustom', response.data.data.blocks);
                    this.$store.commit('builder/setTemplates', response.data.data.templates);
                    this.$store.commit('builder/setAction', response.data.data.email);
                }, () => {
                    this.loading = false;
                });
        },

        setCss(css) {
            let el = document.getElementById('builder-styles');
            if (el) {
                el.innerHTML = css;
            } else {
                let head = document.getElementsByTagName('head')[0];
                let style = document.createElement('style');
                style.id = 'builder-styles';
                style.innerHTML = css;
                head.appendChild(style);
            }
        },

    },

}

</script>
